// Empty translation object as we use generateStringsFile to generate the translation strings in vite config
const translation = {};
export default translation;
